import React, { useState } from 'react';

export const WebRtcInspector: React.FC = () => {
  const [stats] = useState({
    activePeerConnections: 1,
    turnAllocations: 0,
    mediaTracksRelayed: 2,
    screenSharesActive: 1,
  });

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-3">
          <div className="text-[10px] text-neutral-400 uppercase font-mono">Peer Sessions</div>
          <div className="text-xl font-bold text-cyan-400 mt-1">{stats.activePeerConnections}</div>
          <div className="text-[10px] text-emerald-400 mt-0.5">● Coturn Active</div>
        </div>
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-3">
          <div className="text-[10px] text-neutral-400 uppercase font-mono">TURN Allocations</div>
          <div className="text-xl font-bold text-white mt-1">{stats.turnAllocations}</div>
          <div className="text-[10px] text-neutral-400 mt-0.5">Direct P2P Preferred</div>
        </div>
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-3">
          <div className="text-[10px] text-neutral-400 uppercase font-mono">Screen Streams</div>
          <div className="text-xl font-bold text-emerald-400 mt-1">{stats.screenSharesActive}</div>
          <div className="text-[10px] text-cyan-400 mt-0.5">Mixed Tab/Mic Audio</div>
        </div>
        <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-3">
          <div className="text-[10px] text-neutral-400 uppercase font-mono">AV Tracks Active</div>
          <div className="text-xl font-bold text-purple-400 mt-1">{stats.mediaTracksRelayed}</div>
          <div className="text-[10px] text-neutral-400 mt-0.5">Adaptive Bitrate</div>
        </div>
      </div>

      <div className="bg-neutral-900/80 border border-neutral-800 rounded-xl p-4">
        <div className="text-xs font-semibold text-neutral-200 mb-2">Active WebRTC Sessions</div>
        <div className="text-xs font-mono text-neutral-400 divide-y divide-neutral-800">
          <div className="py-2 flex items-center justify-between">
            <div>
              <span className="text-cyan-400 font-bold">#private</span>
              <span className="text-neutral-500 ml-2">Host + Guest Alpha</span>
            </div>
            <span className="px-2 py-0.5 rounded bg-emerald-950 border border-emerald-500/40 text-emerald-300 text-[10px]">
              Screen Share (1080p Text)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
